// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Pervasives from "../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Icon$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as UserRoleConfig from "../../../../../configs/UserRoleConfig.bs.js";
import * as Column$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as StringUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/StringUtils.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as TableComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as PartnerPenaltyAssetsManager from "../assets/PartnerPenaltyAssetsManager.bs.js";

var delete_icon = PartnerPenaltyAssetsManager.getImage("delete-icon.svg");

var disabled_delete_icon = PartnerPenaltyAssetsManager.getImage("disabled-delete-icon.svg");

function getTableColumnsSchema(workspace_dispatch, openDeletePenaltyPanel) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Engagement Type"
            },
            accessor: (function (penalty) {
                return {
                        TAG: /* Text */0,
                        _0: StringUtils$Catalyst.snakeCaseToTitleCase(penalty.engagement_type)
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Order ID"
              },
              accessor: (function (penalty) {
                  return {
                          TAG: /* Text */0,
                          _0: penalty.order_crn
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "MSISDN"
                },
                accessor: (function (penalty) {
                    return {
                            TAG: /* Custom */5,
                            _0: (function (param) {
                                return React.createElement(PrimaryButton$Catalyst.make, {
                                            buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                                  TAG: /* Text */0,
                                                  _0: penalty.msisdn
                                                }, undefined, (function (param) {
                                                    return Curry._2(workspace_dispatch.addTab, {
                                                                TAG: /* DriverDashboardV2 */5,
                                                                _0: penalty.msisdn
                                                              }, false);
                                                  }), undefined, undefined, undefined, undefined, undefined, undefined, undefined)
                                          });
                              })
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Date"
                  },
                  accessor: (function (penalty) {
                      return {
                              TAG: /* Text */0,
                              _0: Timestamp$Catalyst.toString(penalty.date, "DD MMM YYYY")
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Penalty Type"
                    },
                    accessor: (function (penalty) {
                        return {
                                TAG: /* Text */0,
                                _0: penalty.penalty_type
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Amount"
                      },
                      accessor: (function (penalty) {
                          return {
                                  TAG: /* Text */0,
                                  _0: Currency.toString(penalty.amount)
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Applied at"
                        },
                        accessor: (function (penalty) {
                            return {
                                    TAG: /* Text */0,
                                    _0: Timestamp$Catalyst.toString(penalty.applied_at, "DD MMM YYYY, hh:mm A")
                                  };
                          })
                      },
                      tl: {
                        hd: {
                          column: {
                            TAG: /* Text */0,
                            _0: "Applied by"
                          },
                          accessor: (function (penalty) {
                              return {
                                      TAG: /* Text */0,
                                      _0: penalty.applied_by
                                    };
                            })
                        },
                        tl: {
                          hd: {
                            column: {
                              TAG: /* Text */0,
                              _0: "Is waived off"
                            },
                            accessor: (function (penalty) {
                                return {
                                        TAG: /* Text */0,
                                        _0: Pervasives.string_of_bool(penalty.is_waived_off)
                                      };
                              })
                          },
                          tl: {
                            hd: {
                              column: {
                                TAG: /* Text */0,
                                _0: "Categories"
                              },
                              accessor: (function (penalty) {
                                  return {
                                          TAG: /* Text */0,
                                          _0: penalty.category
                                        };
                                })
                            },
                            tl: {
                              hd: {
                                column: {
                                  TAG: /* Text */0,
                                  _0: "Deleted at"
                                },
                                accessor: (function (penalty) {
                                    var data = penalty.deleted_at;
                                    if (data !== undefined) {
                                      return {
                                              TAG: /* Text */0,
                                              _0: Timestamp$Catalyst.toString(Caml_option.valFromOption(data), "DD MMM YYYY, hh:mm A")
                                            };
                                    } else {
                                      return {
                                              TAG: /* Text */0,
                                              _0: "N/A"
                                            };
                                    }
                                  })
                              },
                              tl: {
                                hd: {
                                  column: {
                                    TAG: /* Text */0,
                                    _0: "Deleted by"
                                  },
                                  accessor: (function (penalty) {
                                      var data = penalty.deleted_by;
                                      if (data !== undefined) {
                                        return {
                                                TAG: /* Text */0,
                                                _0: data
                                              };
                                      } else {
                                        return {
                                                TAG: /* Text */0,
                                                _0: "N/A"
                                              };
                                      }
                                    })
                                },
                                tl: {
                                  hd: {
                                    column: {
                                      TAG: /* Text */0,
                                      _0: "Comment"
                                    },
                                    accessor: (function (penalty) {
                                        var data = penalty.deletion_comment;
                                        if (data !== undefined) {
                                          return {
                                                  TAG: /* Text */0,
                                                  _0: data
                                                };
                                        } else {
                                          return {
                                                  TAG: /* Text */0,
                                                  _0: "N/A"
                                                };
                                        }
                                      })
                                  },
                                  tl: {
                                    hd: {
                                      column: {
                                        TAG: /* Text */0,
                                        _0: "Delete"
                                      },
                                      accessor: (function (penalty) {
                                          if (penalty.is_deleted) {
                                            return {
                                                    TAG: /* Text */0,
                                                    _0: "Deleted"
                                                  };
                                          } else if (UserRoleConfig.isUserAllowed(UserRoleConfig.partnerPenaltyDeleteRoles, WorkSpaceContext.useWorkSpace(undefined).user_roles)) {
                                            return {
                                                    TAG: /* Custom */5,
                                                    _0: (function (param) {
                                                        return React.createElement("div", {
                                                                    className: "delete-img-container"
                                                                  }, React.createElement("img", {
                                                                        src: delete_icon,
                                                                        onClick: (function (param) {
                                                                            return Curry._1(openDeletePenaltyPanel, penalty);
                                                                          })
                                                                      }));
                                                      })
                                                  };
                                          } else {
                                            return {
                                                    TAG: /* Custom */5,
                                                    _0: (function (param) {
                                                        return React.createElement("div", {
                                                                    className: "delete-img-container__disabled"
                                                                  }, React.createElement("img", {
                                                                        src: disabled_delete_icon
                                                                      }));
                                                      })
                                                  };
                                          }
                                        })
                                    },
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function PartnerPenaltyListCmp(Props) {
  var tableData = Props.tableData;
  var workspace_dispatch = Props.workspace_dispatch;
  var openDeletePenaltyPanel = Props.openDeletePenaltyPanel;
  var match = List.length(tableData);
  return React.createElement(React.Fragment, undefined, match !== 0 ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                        className: "table-title"
                      }, "Penalty List Result"), React.createElement("div", {
                        className: "table-wrapper"
                      }, React.createElement(TableComponent$Catalyst.make, {
                            columns: getTableColumnsSchema(workspace_dispatch, openDeletePenaltyPanel),
                            rowData: tableData,
                            className: "customTable"
                          }))) : React.createElement(Column$Catalyst.make, {
                    children: null,
                    className: "no-penalty-container"
                  }, React.createElement(Icon$Catalyst.InfoIcon.make, {
                        fontSize: "Large"
                      }), React.createElement("div", {
                        className: "message"
                      }, "No penalty found for this driver!")));
}

var make = PartnerPenaltyListCmp;

export {
  delete_icon ,
  disabled_delete_icon ,
  getTableColumnsSchema ,
  make ,
  
}
/* delete_icon Not a pure module */
